import React from "react";
import { useUID } from "react-uid";

export default function Reveal({ color, size }) {
  const id = useUID();
  const svgSize = size === "sm" ? 12 : 24;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={svgSize}
      height={svgSize}
      viewBox="0 0 24 24"
    >
      <defs>
        <path
          id={id}
          d="M12 0c7.531 0 11.72 8.204 11.894 8.553a.998.998 0 0 1 0 .894C23.72 9.796 19.531 18 12 18S.28 9.796.105 9.447a1.004 1.004 0 0 1 0-.894C.28 8.204 4.469 0 12 0zm0 2C6.606 2 3.076 7.389 2.142 8.999 3.079 10.607 6.623 16 12 16c5.393 0 8.924-5.389 9.858-6.999C20.921 7.393 17.377 2 12 2zm0 3c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4zm0 2c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2z"
        />
      </defs>
      <use
        fill={color}
        fillRule="evenodd"
        transform="translate(0 3)"
        xlinkHref={`#${id}`}
      />
    </svg>
  );
}
